export abstract class KWUtils {
  private static readonly ESTIMATED_TIME_PER_UPDATE_MINUTES: number = 30;

  public static getEstimatedUpdateDurationMinutes(numberOfUpdates: number): number {
    return numberOfUpdates * this.ESTIMATED_TIME_PER_UPDATE_MINUTES;
  }
}
